document.addEventListener("DOMContentLoaded", async function () {
  // console.log("Bundle.js script is running!");

  const bundleContainer = document.getElementById("bundle-selectors");
  if (!bundleContainer) {
    // console.log("Bundle container not found; assuming not a bundle page.");
    return;
  }

  const addToCartButton = document.querySelector(".product-form__submit");
  if (!addToCartButton) {
    console.error("Add to Cart button not found.");
    return;
  }

  const productHandle = window.location.pathname.split("/").pop();

  // Fetch bundle product metafields
  try {
    const response = await fetch(
      "https://skrubz-com.myshopify.com/api/2024-04/graphql.json",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "3f637eb962bb573239f60bd280f71f54",
        },
        body: JSON.stringify({
          query: `
          query ($handle: String!) {
            productByHandle(handle: $handle) {
              id
              title
              metafields(identifiers: [
                {namespace: "custom", key: "bundle_discount"},
                {namespace: "custom", key: "bundle_components"},
                {namespace: "custom", key: "bundle_quantities"}
              ]) {
                id
                namespace
                key
                value
              }
            }
          }
        `,
          variables: { handle: productHandle },
        }),
      }
    );

    const bundleData = await response.json();
    // console.log("Bundle product response:", bundleData);
    if (bundleData.errors || !bundleData.data.productByHandle) {
      console.error(
        "Error fetching bundle product:",
        bundleData.errors || "Product not found"
      );
      return;
    }

    const bundleProduct = bundleData.data.productByHandle;
    const metafields = bundleProduct.metafields.filter((m) => m);

    const bundleComponentsMetafield = metafields.find(
      (m) => m.namespace === "custom" && m.key === "bundle_components"
    );
    if (!bundleComponentsMetafield || !bundleComponentsMetafield.value) {
      // console.log("Not a bundle product; skipping bundle logic.");
      return;
    }

    const bundleTitle = bundleProduct.title;
    const bundleProductId = bundleProduct.id;
    const bundleDiscount = parseFloat(
      metafields.find((m) => m.key === "bundle_discount")?.value || "0"
    );
    let bundleComponents = [];
    let bundleQuantities = [];
    try {
      bundleComponents = JSON.parse(bundleComponentsMetafield.value || "[]");
      bundleQuantities = JSON.parse(
        metafields.find((m) => m.key === "bundle_quantities")?.value || "[]"
      );
    } catch (error) {
      console.error("Error parsing bundle metafields:", error);
      return;
    }

    if (
      bundleComponents.length === 0 ||
      bundleComponents.length !== bundleQuantities.length
    ) {
      console.error(
        "Invalid bundle configuration: components or quantities missing/mismatched."
      );
      return;
    }

    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.value = 1;
      // console.log("Set bundle quantity to 1:", quantityInput);
    }

    // console.log("Bundle quantities from metafields:", bundleQuantities);

    const variantSelections = bundleComponents.map((componentId, index) => ({
      productId: componentId,
      qty: parseInt(bundleQuantities[index] || 1),
      price: 0,
      available: false,
      variantId: null,
      productTitle: "",
    }));

    // Fetch component products
    const componentProducts = await Promise.all(
      bundleComponents.map((componentId) =>
        fetch(
          "https://skrubz-com.myshopify.com/api/2024-04/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "3f637eb962bb573239f60bd280f71f54",
            },
            body: JSON.stringify({
              query: `
              query ($id: ID!) {
                product(id: $id) {
                  id
                  title
                  featuredImage { url altText }
                  options { name values }
                  variants(first: 250) {
                    edges {
                      node {
                        id
                        title
                        priceV2 { amount currencyCode }
                        availableForSale
                        selectedOptions { name value }
                        sku
                      }
                    }
                  }
                }
              }
              `,
              variables: { id: componentId },
            }),
          }
        ).then(async (res) => {
          const data = await res.json();
          if (data.data.product) {
            console.log(
              `Fetched product ${componentId}: ${data.data.product.title}, Variants count: ${data.data.product.variants.edges.length}`,
              data.data.product.variants.edges.map(({ node }) => ({
                id: node.id,
                sku: node.sku,
                options: node.selectedOptions,
              }))
            );
          }
          return data;
        })
      )
    );

    // Build product boxes
    componentProducts.forEach((data, index) => {
      if (data.errors || !data.data.product) {
        console.error(`Error fetching component ${index}:`, data.errors);
        return;
      }

      const product = data.data.product;
      const requiredQty = parseInt(bundleQuantities[index] || 1);
      variantSelections[index].productTitle = product.title;

      const productBox = document.createElement("div");
      productBox.className = "product-box";
      productBox.dataset.productId = product.id;
      productBox.dataset.quantity = requiredQty;

      const imageBox = document.createElement("div");
      imageBox.className = "imagbox";

      const image = document.createElement("img");
      image.src = product.featuredImage?.url || "https://via.placeholder.com/150";
      image.alt = product.featuredImage?.altText || product.title;

      imageBox.appendChild(image);
      productBox.appendChild(imageBox);

      const detailWrap = document.createElement("div");
      detailWrap.className = "detailwrap";

      const title = document.createElement("h3");
      title.innerText = `Choose ${product.title} (Qty: ${requiredQty})`;
      detailWrap.appendChild(title);

      const availabilityDiv = document.createElement("div");
      availabilityDiv.className = "variant-availability";
      availabilityDiv.innerText = "Select variants";
      availabilityDiv.style.color = "gray";
      detailWrap.appendChild(availabilityDiv);

      const variantContainer = document.createElement("div");
      variantContainer.className = "variant-container";

      setTimeout(function () {
        detailWrap.appendChild(variantContainer);
      }, 100);

      productBox.appendChild(detailWrap);

      product.options.forEach((option) => {
        const label = document.createElement("label");
        label.innerText = option.name;
        const select = document.createElement("select");
        select.dataset.optionName = option.name;

        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        defaultOption.innerText = `Select ${option.name}`;
        select.appendChild(defaultOption);

        option.values.forEach((value) => {
          const opt = document.createElement("option");
          opt.value = value;
          opt.innerText = value;
          select.appendChild(opt);
        });

        select.addEventListener("change", async () => {
          variantSelections[index][option.name] = select.value.trim();

          const dropdowns = variantContainer.querySelectorAll('select[data-option-name]');
          const selectedOptions = Array.from(dropdowns)
            .map((select) => ({
              name: select.dataset.optionName,
              value: select.value.trim(),
            }))
            .filter((opt) => opt.value);

          // console.log("Current dropdown selections:", selectedOptions);

          const variant = product.variants.edges.find(({ node }) =>
            selectedOptions.length === node.selectedOptions.length &&
            selectedOptions.every((selectedOpt) =>
              node.selectedOptions.some(
                (variantOpt) =>
                  variantOpt.name === selectedOpt.name &&
                  variantOpt.value.trim().toLowerCase() === selectedOpt.value.toLowerCase()
              )
            )
          )?.node;

          console.log(
            "Found variant:",
            variant ? { id: variant.id, sku: variant.sku, title: variant.title } : "None"
          );

          if (variant) {
            try {
              const inventoryResponse = await fetch(
                `https://skrubz-com.myshopify.com/admin/api/2024-04/variants/${variant.id
                  .split("/")
                  .pop()}.json`,
                {
                  method: "GET",
                  headers: {
                    "X-Shopify-Access-Token": "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",
                    "Content-Type": "application/json",
                  },
                }
              );
              const inventoryData = await inventoryResponse.json();
              const inventoryQty = inventoryData.variant?.inventory_quantity || 0;
              const availableForSale = inventoryData.variant?.availableForSale || false;
              const imageId = inventoryData.variant?.image_id;

              console.log(
                "Inventory response for",
                variant.sku,
                ":",
                JSON.stringify(inventoryData, null, 2)
              );
              console.log(
                "Variant:",
                variant.id,
                "SKU:",
                variant.sku,
                "Title:",
                variant.title,
                "Inventory:",
                inventoryQty,
                "AvailableForSale:",
                availableForSale,
                "RequiredQty:",
                requiredQty,
                "ImageId:",
                imageId
              );

              let variantImage = { src: image.src, alt: image.alt };
              if (imageId) {
                try {
                  const imageResponse = await fetch(
                    `https://skrubz-com.myshopify.com/admin/api/2025-07/products/${product.id.split("/").pop()}/images/${imageId}.json`,
                    {
                      method: "GET",
                      headers: {
                        "X-Shopify-Access-Token": "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",
                        "Content-Type": "application/json",
                      },
                    }
                  );
                  const imageData = await imageResponse.json();
                  if (imageData.image?.src) {
                    variantImage = {
                      src: imageData.image.src,
                      alt: imageData.image.alt || `${variant.title} Image`,
                    };
                    console.log(
                      `Fetched variant image for ${variant.sku}:`,
                      variantImage
                    );
                  } else {
                    console.warn(`No image found for image_id ${imageId}`);
                  }
                } catch (error) {
                  console.error(
                    `Error fetching image for image_id ${imageId}:`,
                    error
                  );
                }
              }

              image.src = variantImage.src;
              image.alt = variantImage.alt;

              variantSelections[index].variantId = variant.id;
              variantSelections[index].price = parseFloat(variant.priceV2.amount);
              variantSelections[index].available = inventoryQty >= requiredQty;

              availabilityDiv.innerText = variantSelections[index].available
                ? "In Stock"
                : "Out of Stock";
              availabilityDiv.style.color = variantSelections[index].available ? "green" : "red";
            } catch (error) {
              console.error("Error fetching inventory for", variant.sku, ":", error);
              variantSelections[index].variantId = variant.id;
              variantSelections[index].available = false;
              variantSelections[index].price = parseFloat(variant.priceV2.amount);
              availabilityDiv.innerText = "Error checking stock";
              availabilityDiv.style.color = "gray";
            }
          } else {
            console.log(
              "Available variants:",
              product.variants.edges.map(({ node }) => ({
                id: node.id,
                sku: node.sku,
                title: node.title,
                options: node.selectedOptions,
              }))
            );
            image.src = product.featuredImage?.url || "https://via.placeholder.com/150";
            image.alt = product.featuredImage?.altText || product.title;
            variantSelections[index].variantId = null;
            variantSelections[index].available = false;
            variantSelections[index].price = 0;
            availabilityDiv.innerText = "Invalid selection";
            availabilityDiv.style.color = "gray";
          }

          checkAllSelections();
        });

        variantContainer.appendChild(label);
        variantContainer.appendChild(select);
      });

      bundleContainer.appendChild(productBox);
    });

    function checkAllSelections() {
      let allSelected = true;
      let total = 0;

      variantSelections.forEach((sel) => {
        if (!sel.variantId || !sel.available) {
          allSelected = false;
        } else {
          total += sel.price * sel.qty;
        }
      });

      if (allSelected) {
        const bundleQuantity = parseInt(quantityInput?.value || 1);
        const originalTotal = total * bundleQuantity;
        const discountAmount = originalTotal * (bundleDiscount / 100);
        total = originalTotal - discountAmount;

        addToCartButton.disabled = false;
        addToCartButton.innerText = "Add Bundle to Cart";
        addToCartButton.removeAttribute("ymq-add-to-cart-tags");

        const priceContainer = document.getElementById("bundle-price");
        if (priceContainer) {
          priceContainer.innerHTML = `
            Total Price: <s>£${originalTotal.toFixed(2)}</s> £${total.toFixed(
            2
          )}
            <br><small>PRODUCTS BUNDLE (-${bundleDiscount}% / -£${discountAmount.toFixed(
            2
          )})</small>
          `;
        }
      } else {
        addToCartButton.disabled = true;
        addToCartButton.innerText = "Select All Variants";
      }
    }

    const quantityButtons = document.querySelectorAll(".quantity__button");
    quantityButtons.forEach((button) => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      newButton.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const currentQty = parseInt(quantityInput.value) || 1;
        let newQty = currentQty;

        if (newButton.name === "plus" && currentQty < 100) {
          newQty = currentQty + 1;
        } else if (newButton.name === "minus" && currentQty > 1) {
          newQty = currentQty - 1;
        }

        quantityInput.value = newQty;
        console.log(`Quantity updated: ${newQty}`);

        const minusButton = document.querySelector('.quantity__button[name="minus"]');
        const plusButton = document.querySelector('.quantity__button[name="plus"]');
        if (minusButton) {
          if (newQty <= 1) {
            minusButton.setAttribute("disabled", "disabled");
            minusButton.classList.add("disabled");
          } else {
            minusButton.removeAttribute("disabled");
            minusButton.classList.remove("disabled");
          }
        }
        if (plusButton) {
          if (newQty >= 100) {
            plusButton.setAttribute("disabled", "disabled");
            plusButton.classList.add("disabled");
          } else {
            plusButton.removeAttribute("disabled");
            plusButton.classList.remove("disabled");
          }
        }

        checkAllSelections();
      });
    });

    addToCartButton.addEventListener("click", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      // Show "Adding..." state
      const originalText = addToCartButton.innerText;
      addToCartButton.disabled = true;
      addToCartButton.innerText = "Adding...";

      try {
        const bundleQuantity = parseInt(quantityInput?.value || 1);
        const items = variantSelections
          .filter((sel) => sel.variantId && sel.available)
          .map((sel, index) => {
            const originalPrice = sel.price * sel.qty * bundleQuantity;
            const discountAmount = originalPrice * (bundleDiscount / 100);
            return {
              merchandiseId: sel.variantId,
              quantity: sel.qty * bundleQuantity,
              attributes: [
                { key: "_isBundle", value: "true" },
                { key: "Bundle Name", value: bundleTitle },
                {
                  key: "Bundle Discount",
                  value: `PRODUCTS BUNDLE (-${bundleDiscount}% / -£${discountAmount.toFixed(
                    2
                  )})`,
                },
              ],
              productTitle: sel.productTitle,
              variantTitle: componentProducts[index].data.product.variants.edges.find(
                ({ node }) => node.id === sel.variantId
              )?.node.title || "Unknown Variant",
            };
          });

        if (items.length === 0) {
          console.error("No valid items to add to cart");
          alert("Error: No valid items to add to cart.");
          addToCartButton.disabled = false;
          addToCartButton.innerText = originalText;
          return;
        }

        for (const item of items) {
          try {
            const variantId = item.merchandiseId.split("/").pop();
            const inventoryResponse = await fetch(
              `https://skrubz-com.myshopify.com/admin/api/2024-04/variants/${variantId}.json`,
              {
                method: "GET",
                headers: {
                  "X-Shopify-Access-Token": "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",
                  "Content-Type": "application/json",
                },
              }
            );
            const inventoryData = await inventoryResponse.json();
            const inventoryQty = inventoryData.variant?.inventory_quantity || 0;

            console.log(
              "Cart validation for",
              item.productTitle,
              item.variantTitle,
              ": Inventory:",
              inventoryQty,
              "Requested:",
              item.quantity
            );

            if (inventoryQty < item.quantity) {
              console.error(
                `Out of stock for ${item.productTitle} (${item.variantTitle}): requested ${item.quantity}, available ${inventoryQty}`
              );
              alert(
                `Error: ${item.productTitle} (${item.variantTitle}) is out of stock. Only ${inventoryQty} units available. Please select a different variant.`
              );
              addToCartButton.disabled = false;
              addToCartButton.innerText = originalText;
              return;
            }
          } catch (error) {
            console.error(
              `Error checking inventory for ${item.productTitle} (${item.variantTitle}):`,
              error
            );
            alert(
              `Error: Unable to verify stock for ${item.productTitle} (${item.variantTitle}). Please try again or contact support.`
            );
            addToCartButton.disabled = false;
            addToCartButton.innerText = originalText;
            return;
          }
        }

        console.log("Cart items payload:", JSON.stringify(items));

        console.log("Creating new cart");
        localStorage.removeItem("cartId");
        const createCartResponse = await fetch(
          "https://skrubz-com.myshopify.com/api/2024-04/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "3f637eb962bb573239f60bd280f71f54",
            },
            body: JSON.stringify({
              query: `
              mutation {
                cartCreate(input: {}) {
                  cart {
                    id
                    checkoutUrl
                    buyerIdentity {
                      countryCode
                    }
                    cost {
                      subtotalAmount { amount currencyCode }
                      totalTaxAmount { amount }
                      totalAmount { amount }
                    }
                  }
                  userErrors { field message }
                }
              }
            `,
            variables: {
        country: "GB"  // Explicitly set to UK
      },
            }),
          }
        );
        const cartData = await createCartResponse.json();
        console.log("Cart create response:", cartData);
        if (
          cartData.errors ||
          !cartData.data.cartCreate.cart ||
          cartData.data.cartCreate.userErrors.length > 0
        ) {
          throw new Error(
            "Failed to create cart: " +
              JSON.stringify(
                cartData.errors || cartData.data.cartCreate.userErrors
              )
          );
        }
        const cartId = cartData.data.cartCreate.cart.id;
        const checkoutUrl = cartData.data.cartCreate.cart.checkoutUrl;
        const customerCountry = cartData.data.cartCreate.cart.buyerIdentity?.countryCode || "GB";
        const initialTax = parseFloat(cartData.data.cartCreate.cart.cost.totalTaxAmount?.amount || 0);
        console.log("Customer country from cart:", customerCountry, "Initial tax:", initialTax);

        localStorage.setItem("cartId", cartId);

        console.log("Adding items to Storefront API cart");
        const addItemsResponse = await fetch(
          "https://skrubz-com.myshopify.com/api/2024-04/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "3f637eb962bb573239f60bd280f71f54",
            },
            body: JSON.stringify({
              query: `
              mutation ($cartId: ID!, $lines: [CartLineInput!]!) {
                cartLinesAdd(cartId: $cartId, lines: $lines) {
                  cart {
                    id
                    checkoutUrl
                    totalQuantity
                    cost {
                      totalAmount { amount currencyCode }
                      subtotalAmount { amount }
                      totalTaxAmount { amount }
                    }
                    lines(first: 100) {
                      edges {
                        node {
                          id
                          quantity
                          merchandise {
                            ... on ProductVariant {
                              id
                              product { id title }
                              priceV2 { amount }
                            }
                          }
                          attributes { key value }
                        }
                      }
                    }
                  }
                  userErrors { field message }
                }
              }
            `,
              variables: {
                cartId,
                lines: items.map(({ merchandiseId, quantity, attributes }) => ({
                  merchandiseId,
                  quantity,
                  attributes,
                })),
              },
            }),
          }
        );

        const addData = await addItemsResponse.json();
        console.log("Cart lines add response:", addData);
        if (
          addData.errors ||
          !addData.data.cartLinesAdd.cart ||
          addData.data.cartLinesAdd.userErrors.length > 0
        ) {
          throw new Error(
            "Failed to add items: " +
              JSON.stringify(
                addData.errors || addData.data.cartLinesAdd.userErrors
              )
          );
        }
        console.log("Items added:", addData.data.cartLinesAdd.cart.lines.edges);
        const addedItems = addData.data.cartLinesAdd.cart.lines.edges;
        const totalQuantity = addData.data.cartLinesAdd.cart.totalQuantity;

        const expectedQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
        if (totalQuantity !== expectedQuantity) {
          console.error("Cart items not added correctly:", {
            totalQuantity,
            expectedQuantity,
            addedItems,
          });
          const problematicItem = addedItems.find(
            ({ node }) =>
              node.quantity !==
              items.find((item) => item.merchandiseId === node.merchandise.id).quantity
          );
          if (problematicItem) {
            const productTitle = problematicItem.node.merchandise.product.title;
            const variantTitle = problematicItem.node.merchandise.title;
            const requestedQty = items.find(
              (item) => item.merchandiseId === problematicItem.node.merchandise.id
            ).quantity;
            const addedQty = problematicItem.node.quantity;
            throw new Error(
              `${productTitle} (${variantTitle}) is out of stock. Requested ${requestedQty} units, but only ${addedQty} added. Please select a different variant.`
            );
          }
          throw new Error(
            `Cart items not added correctly: totalQuantity is ${totalQuantity}, expected ${expectedQuantity}`
          );
        }

        console.log("Updating cart attributes");
        const cartUpdateResponse = await fetch(
          "https://skrubz-com.myshopify.com/api/2024-04/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "3f637eb962bb573239f60bd280f71f54",
            },
            body: JSON.stringify({
              query: `
              mutation ($cartId: ID!, $attributes: [AttributeInput!]!) {
                cartAttributesUpdate(cartId: $cartId, attributes: $attributes) {
                  cart { id }
                  userErrors { field message }
                }
              }
            `,
              variables: {
                cartId,
                attributes: [
                  { key: "_bundleName", value: bundleTitle },
                  { key: "_bundleProductId", value: bundleProductId },
                ],
              },
            }),
          }
        );
        const updateData = await cartUpdateResponse.json();
        console.log("Cart attributes update response:", updateData);
        if (
          updateData.errors ||
          updateData.data.cartAttributesUpdate.userErrors.length > 0
        ) {
          console.error(
            "Failed to update cart attributes:",
            updateData.errors || updateData.data.cartAttributesUpdate.userErrors
          );
        }

        const cartItemsPayload = items.map((item) => ({
          id: item.merchandiseId.split("/").pop(),
          productId: variantSelections
            .find((sel) => sel.variantId === item.merchandiseId)
            .productId.split("/")
            .pop(),
          quantity: item.quantity,
          properties: Object.fromEntries(
            item.attributes.map((attr) => [attr.key, attr.value])
          ),
        }));

        console.log(
          "Discount payload:",
          JSON.stringify({
            cartItems: cartItemsPayload,
            bundleName: bundleTitle,
            productId: bundleProductId.split("/").pop(),
            cartId,
          })
        );

        const discountResponse = await retryFetch(
          "https://shopify.cleartwo.co.uk/shopify-bundle-app/apply-bundle-discount.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              cartItems: cartItemsPayload,
              bundleName: bundleTitle,
              productId: bundleProductId.split("/").pop(),
              cartId,
            }),
          },
          3,
          1000
        );

        const discountResult = await discountResponse.json();
        console.log("Discount response:", discountResult);
        if (!discountResponse.ok || discountResult.error) {
          throw new Error(
            `Failed to apply bundle discount: ${
              discountResult.error || "Unknown error"
            }`
          );
        }

        console.log("Applying discount code:", discountResult.discount_code);
        const discountMutation = `
          mutation ($cartId: ID!, $discountCodes: [String!]!) {
            cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
              cart {
                id
                totalQuantity
                cost {
                  totalAmount { amount currencyCode }
                  subtotalAmount { amount }
                  totalTaxAmount { amount }
                }
                discountCodes { code applicable }
              }
              userErrors { field message }
            }
          }
        `;
        const discountApplyResponse = await fetch(
          "https://skrubz-com.myshopify.com/api/2024-04/graphql.json",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token": "3f637eb962bb573239f60bd280f71f54",
            },
            body: JSON.stringify({
              query: discountMutation,
              variables: {
                cartId,
                discountCodes: [discountResult.discount_code],
              },
            }),
          }
        );

        const discountApplyData = await discountApplyResponse.json();
        console.log("Discount apply response:", discountApplyData);
        if (
          discountApplyData.errors ||
          discountApplyData.data.cartDiscountCodesUpdate.userErrors.length > 0
        ) {
          throw new Error(
            "Failed to apply discount code: " +
              JSON.stringify(
                discountApplyData.errors ||
                  discountApplyData.data.cartDiscountCodesUpdate.userErrors
              )
          );
        }
        if (
          !discountApplyData.data.cartDiscountCodesUpdate.cart.discountCodes[0]
            .applicable
        ) {
          throw new Error(
            `Discount code ${discountResult.discount_code} not applicable`
          );
        }

        // Calculate expected total using Shopify's tax data
        const subtotal = parseFloat(
          discountApplyData.data.cartDiscountCodesUpdate.cart.cost.subtotalAmount.amount
        );
        const cartTax = parseFloat(
          discountApplyData.data.cartDiscountCodesUpdate.cart.cost.totalTaxAmount.amount
        );
        const expectedTotal = subtotal + cartTax;

        const cartTotal = parseFloat(
          discountApplyData.data.cartDiscountCodesUpdate.cart.cost.totalAmount.amount
        );

        console.log("Cart cost details:", {
          cartTotal,
          subtotal,
          cartTax,
          expectedTotal,
          customerCountry,
        });

        if (Math.abs(cartTotal - expectedTotal) > 0.01) {
          console.error("Cart total incorrect:", { cartTotal, expectedTotal });
          throw new Error(
            `Cart total incorrect: got £${cartTotal.toFixed(
              2
            )}, expected £${expectedTotal.toFixed(2)}`
          );
        }

        console.log("Redirecting to checkout");
        window.location.href = checkoutUrl;
        addToCartButton.disabled = false;
        addToCartButton.innerText = originalText;
      } catch (error) {
        console.error("Cart add error:", error);
        alert(`Error: ${error.message}. Please try again or contact support.`);
        addToCartButton.disabled = false;
        addToCartButton.innerText = originalText;
      }
    });

    async function retryFetch(url, options, retries = 3, delay = 1000) {
      for (let i = 0; i < retries; i++) {
        try {
          const response = await fetch(url, options);
          if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(
              `HTTP error! Status: ${
                response.status
              }, Details: ${JSON.stringify(errorData)}`
            );
          }
          return response;
        } catch (error) {
          if (i < retries - 1) {
            console.log(
              `Retrying fetch (${i + 1}/${retries}) after ${delay}ms: ${
                error.message
              }`
            );
            await new Promise((resolve) => setTimeout(resolve, delay));
            continue;
          }
          throw error;
        }
      }
    }
  } catch (error) {
    console.error("Error in bundle initialization:", error);
    addToCartButton.disabled = false;
    addToCartButton.innerText = "Add Bundle to Cart";
  }
});